function AllGlobals() {}

AllGlobals.prototype.toggleCB = (cb) => {
    cb(prev => {
        console.log(!prev);
        return !prev
    });
}

AllGlobals.prototype.assignNewPlayerInfo = function (name, isSub) {
    this.name = name;
    this.singles = 0;
    this.doubles = 0;
    this.triples = 0;
    this.homeruns = 0;
    this.outs = 0;
    this.strikeouts = 0;
    this.games = 0;
    this.rbis = 0;
    this.sbs = 0;
    this.walks = 0;
    this.isSub = isSub;
}

AllGlobals.prototype.taskNumbers = Object.freeze({
    none: 0,
    add: 1,
    edit: 2,
    remove: 3,
    deletePlayerRequest: 4,
    approvePlayerRequest: 5
})

AllGlobals.prototype.addItem = (item, setActiveFilters) => {
    setActiveFilters(prev => new Set(prev).add(item));
}

AllGlobals.prototype.removeItem = (item, setActiveFilters) => {
    setActiveFilters(prev => {
        const next = new Set(prev);
        next.delete(item);
        return next;
    });
}

AllGlobals.prototype.calculateAverage = (player) => {
    const average = (player.singles + player.doubles + player.triples + player.homeruns) / (player.singles + player.doubles + player.triples + player.homeruns + player.strikeouts + player.outs);
    const zero = 0;
    return isNaN(average) || 0 ? zero.toFixed(2) : average.toFixed(2);
};


AllGlobals.prototype.determineSort = function (a, b, sortBy, sortAsc) {
    if (sortBy === 'avg') {
        const greaterThan = this.calculateAverage(a) > this.calculateAverage(b);
        if(sortAsc)
            return greaterThan ? 1 : -1;
        else
            return greaterThan ? -1 : 1;
    }

    if (sortAsc)
        return a[sortBy] > b[sortBy] ? 1 : -1
    else 
        return a[sortBy] > b[sortBy] ? -1 : 1
}

AllGlobals.prototype.determineFilter = (compareObject, activeFilters, filterOptions) => {
    let filterObject = {};
    for (const filterOption of filterOptions) {
        filterObject = filterOption.filterIfZero ? !compareObject[filterOption.compareTo] : compareObject[filterOption.compareTo];
        if(!activeFilters.has(filterOption.id) && filterObject)
            return false;   
    }
    return true;


    // if(!activeFilters.has(showSubs.id) && player.isSub)
    //     return false;
    // if(!activeFilters.has(noGamesPlayed.id) && !player.games)
    //     return false
}


const Globals = new AllGlobals();
export default Globals;
